import { render, staticRenderFns } from "./regnota.vue?vue&type=template&id=0b83e9bb"
import script from "./regnota.vue?vue&type=script&lang=js"
export * from "./regnota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports